import { useMemo } from 'react'

export function trendDateStringToDate(dateStr) {
  return new Date(+dateStr.substring(0, 4), +dateStr.substring(4, 6) - 1, +dateStr.substring(6, 8))
}

function mapLine(name, data, dataMap) {
  return Object.keys(data || []).map((dateStr) => ({
    [name]: dataMap(data[dateStr]),
    date: trendDateStringToDate(dateStr),
  }))
}

export default function useEventsChartDataConverter(trendsData, dataMap = (data) => data.change) {
  const lines = useMemo(
    () => [
      ...Object.keys(trendsData || {}).reduce(
        (result, key) => [...result, ...(key ? mapLine(key, trendsData[key], dataMap) : [])],
        []
      ),
    ],
    [trendsData]
  )

  const data = useMemo(() => {
    const mapByDate = lines.reduce(
      (result, cur) => ({ ...result, [cur.date]: [...(result[cur.date] || []), cur] }),
      {}
    )
    return Object.keys(mapByDate).map((key) => {
      return mapByDate[key].reduce((res, cur) => ({ ...res, ...cur }), {})
    })
  }, [lines])

  if (!trendsData) {
    return []
  }

  return data || []
}
